import { Button, Icon } from '@aqarmap/aqarmap-ui';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setRatedListing } from '~/redux/features/listing/listingSlice';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import { getSavedPropertyListingRoute } from '~activities/pages/Favorites/utils';
import { SavedPropertyItemType } from '~/types/activitiesTypes';
import FavoriteListingItem from '~activities/pages/Favorites/FavoriteListingItem';

const ActionMenu = ({
  listingData,
  handleDeleteNote,
  handelDeleteFavorite,
  isSheared,
  setShareRoute,
}: {
  listingData: SavedPropertyItemType;
  handleDeleteNote: () => void;
  handelDeleteFavorite: () => void;
  isSheared?: boolean;
  setShareRoute: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const actionMenuRef = React.useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const dispatch = useAppDispatch();

  const listingNote = listingData.note;
  const listingId = listingData.listing.id;

  const handleShareProperty = () => {
    const route = getSavedPropertyListingRoute(listingData.listing, locale);
    setShareRoute(route);
    dispatch(openModal('share'));
    setIsMenuOpen(false);
  };

  const handleReportProperty = () => {
    dispatch(setRatedListing({ id: listingId }));
    dispatch(openModal('reportModal'));
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        actionMenuRef.current &&
        !actionMenuRef.current.contains(event.target as Node)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className="flex justify-start absolute top-2x md:top-3x end-1.5x md:end-3x w-max h-[40px] z-1">
      <div ref={actionMenuRef} className="relative flex items-center gap-2x">
        {!isSheared && (
          <Button
            variant="link"
            size="medium"
            ariaLabel={t('savedPropertiesDeleteSingle')}
            className="p-0 !w-[40px] !h-[40px] element-center rounded-full bg-gray_light_1 hidden md:flex"
            onClick={handelDeleteFavorite}
          >
            <Icon
              name="heart"
              className="text-red_dark [&_path]:!fill-red_dark"
            />
          </Button>
        )}
        <Button
          variant="link"
          size="medium"
          ariaLabel={t('savedPropertiesOpenMenu')}
          onClick={() => setIsMenuOpen((prevState) => !prevState)}
          className="p-0 !w-[40px] !h-[40px] element-center rounded-full bg-gray_light_1"
        >
          <Icon name="more" className="text-gray__dark_2 rotate-90" />
        </Button>

        {isMenuOpen ? (
          <div className="z-50 flex flex-col gap-y-2x w-max absolute end-0 top-[calc(100%+8px)] rounded-[12px] border border-gray bg-white px-2x py-3x">
            {!isSheared && (
              <FavoriteListingItem
                label={t('removeFromFavorites')}
                icon={
                  <Icon
                    name="heart"
                    className="text-red_dark [&_path]:!fill-red_dark"
                  />
                }
                onClick={handelDeleteFavorite}
              />
            )}
            <FavoriteListingItem
              label={t('savedPropertiesShareProperty')}
              icon={
                <Icon name="share" size="24px" className="text-gray__dark_2" />
              }
              onClick={handleShareProperty}
            />
            {listingNote && !isSheared && (
              <FavoriteListingItem
                label={t('savedPropertiesDeleteNote')}
                icon={
                  <Icon
                    name="trash"
                    size="24px"
                    className="text-gray__dark_2"
                  />
                }
                onClick={() => {
                  handleDeleteNote();
                  setIsMenuOpen(false);
                }}
              />
            )}
            <FavoriteListingItem
              label={t('savedPropertiesReport')}
              icon={
                <Icon name="report" size="24px" className="text-gray__dark_2" />
              }
              onClick={() => {
                handleReportProperty();
                setIsMenuOpen(false);
              }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ActionMenu;
